<template>
  <div v-if="!logado" id="telaLogin">
    <div class="login-ambiente" aria-hidden="true">
      <span class="login-orbe login-orbe-1"></span>
      <span class="login-orbe login-orbe-2"></span>
    </div>
    <div class="boxLogin">
      <div class="login-logo-wrap">
        <img :src="logoMarca" class="login-logo-img" />
      </div>
      <div class="logo">ConGestor</div>
      <div class="subtitulo">Clareza para gerir. Controle para crescer.</div>
      <div class="login-campos">
        <label>Empresa</label>
        <input type="text" v-model="empresa" placeholder="Informe sua empresa" @keyup.enter="entrar" @blur="carregarLogo" />
        <label>Usuário</label>
        <input type="text" v-model="usuario" placeholder="Seu usuário" @keyup.enter="entrar" />
        <label>Senha</label>
        <div class="login-senha-wrap">
          <input :type="mostrarSenha ? 'text' : 'password'" v-model="senha" placeholder="Sua senha" @keyup.enter="entrar" />
          <button type="button" class="login-senha-olho" @click="mostrarSenha = !mostrarSenha" :aria-label="mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'" tabindex="-1">
            <EyeOff v-if="mostrarSenha" :size="17" />
            <Eye v-else :size="17" />
          </button>
        </div>
      </div>
      <button class="login-submit" :disabled="entrando" @click="entrar">{{ entrando ? 'ENTRANDO...' : 'ENTRAR' }}</button>
      <div class="erro-msg">{{ erroLogin }}</div>
      <div class="login-seguranca"><span></span> Acesso seguro ao ambiente da empresa</div>
    </div>
  </div>

  <div v-else id="telaApp">
    <button class="hamburger-btn" :class="{ aberto: menuMobileAberto }" @click="menuMobileAberto = !menuMobileAberto" aria-label="Menu">
      <span></span><span></span><span></span>
    </button>
    <div class="overlay-menu" :class="{ visivel: menuMobileAberto }" @click="menuMobileAberto = false"></div>

    <div class="sidebar" :class="{ aberta: menuMobileAberto, recolhida: sidebarRecolhida }">
      <div class="sidebar-perfil-mobile">
        <div class="sidebar-perfil-avatar-wrap">
          <div class="sidebar-perfil-avatar-iniciais">{{ iniciais }}</div>
        </div>
        <div class="sidebar-perfil-nome">{{ sessao.nome }}</div>
        <div class="sidebar-perfil-cargo">{{ nomeEmpresa }}</div>
        <div class="sidebar-perfil-badge">{{ sessao.perfil }}</div>
      </div>

      <div class="sidebar-logo-wrap">
        <div class="sidebar-brand-icon">
          <img :src="logoConGestor" class="sidebar-logo-img" />
        </div>
        <div class="sidebar-brand-copy">
          <div class="sidebar-logo">ConGestor</div>
          <div class="sidebar-brand-subtitle">Clareza para gerir</div>
        </div>
      </div>
      <div class="sidebar-usuario">
        <div class="sidebar-user-avatar">{{ iniciais }}</div>
        <div class="sidebar-user-copy"><strong>{{ sessao.nome }}</strong><span>{{ sessao.perfil }}</span></div>
      </div>

      <div class="sidebar-menu">
        <div class="sidebar-menu-label">Menu principal</div>
        <div v-for="item in menuVisivel" :key="item.id"
             class="menu-item" :class="{ ativo: paginaAtual === item.id }"
             @click="irPara(item.id)">
          <span class="menu-item-icon"><component :is="iconesMenu[item.icone]" :size="16" /></span><span>{{ item.label }}</span>
        </div>
      </div>
      <div class="menu-sair" @click="sair"><span class="menu-sair-icon"><LogOut :size="15" /></span> Encerrar sessão</div>
    </div>

    <div class="conteudo">
      <header class="app-topbar">
        <div class="topbar-heading">
          <button class="sidebar-toggle" @click="sidebarRecolhida = !sidebarRecolhida" :aria-label="sidebarRecolhida ? 'Mostrar barra lateral' : 'Ocultar barra lateral'" :title="sidebarRecolhida ? 'Mostrar barra lateral' : 'Ocultar barra lateral'">
            <Menu :size="18" :class="{ invertido: sidebarRecolhida }" />
          </button>
          <div><span class="topbar-eyebrow">Área de trabalho</span><strong>{{ nomeEmpresa }}</strong></div>
        </div>
        <div class="topbar-profile">
          <div class="topbar-profile-text"><strong>{{ sessao.nome }}</strong><span>{{ sessao.perfil }}</span></div>
          <div class="topbar-avatar">{{ iniciais }}</div>
        </div>
      </header>
      <main class="app-page"><component :is="paginaComponente" /></main>
    </div>
    <AjudaChat />
  </div>

  <transition name="splash-fade">
    <div v-if="mostrarSplash" class="splash-boasvindas">
      <div class="splash-card">
        <img v-if="empresaLogo" :src="empresaLogo" class="splash-logo" />
        <div class="splash-label">Acessando o ambiente</div>
        <div class="splash-empresa">{{ empresaNome || empresa }}</div>
        <div class="splash-saudacao">Bem-vindo(a), {{ sessao.nome }}</div>
        <div class="splash-linha"></div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.splash-boasvindas{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;background:radial-gradient(circle at 50% 45%,rgba(201,178,142,.14),transparent 34%),#111315;backdrop-filter:blur(8px);}
.splash-card{display:flex;flex-direction:column;align-items:center;gap:11px;animation:splash-pop .72s cubic-bezier(.2,.85,.2,1) both;}
.splash-logo{width:112px;height:112px;object-fit:contain;border-radius:18px;background:#fff;border:1px solid rgba(201,178,142,.28);padding:10px;box-shadow:0 20px 55px rgba(0,0,0,.45);margin-bottom:10px;}
.splash-label{color:rgba(255,255,255,.42);font-size:9px;font-weight:800;letter-spacing:.2em;text-transform:uppercase}
.splash-empresa{color:#f6f1e9;font-size:clamp(25px,4vw,42px);font-weight:850;letter-spacing:-.04em;}
.splash-saudacao{color:rgba(255,255,255,0.64);font-size:13px;}
.splash-linha{width:38px;height:2px;margin-top:8px;background:#c9b28e;animation:splash-linha .9s .2s ease both}
@keyframes splash-pop{from{opacity:0;transform:scale(.92) translateY(18px);filter:blur(7px)}to{opacity:1;transform:none;filter:blur(0)}}
@keyframes splash-linha{from{opacity:0;transform:scaleX(0)}to{opacity:1;transform:scaleX(1)}}
.splash-fade-enter-active{transition:opacity .25s ease;}
.splash-fade-leave-active{transition:opacity .5s ease;}
.splash-fade-enter-from,.splash-fade-leave-to{opacity:0;}
</style>

<script>
import { apiGet, apiPublicPost, apiPublicGet, setSession, getSession, clearSession, setNomeEmpresaCache, aplicarCorTema, limparCorTema } from './api'
import logoMarca from './assets/congestor-simbolo.svg'
import logoConGestor from './assets/congestor-simbolo-reverso.svg'
import Inicio from './pages/Inicio.vue'
import Links from './pages/Links.vue'
import Vendas from './pages/Vendas.vue'
import MinhasVendas from './pages/MinhasVendas.vue'
import Comissao from './pages/Comissao.vue'
import TabelaComissao from './pages/TabelaComissao.vue'
import Pagamentos from './pages/Pagamentos.vue'
import MinhaSenha from './pages/MinhaSenha.vue'
import Metas from './pages/Metas.vue'
import ContasPagar from './pages/ContasPagar.vue'
import Sorteios from './pages/Sorteios.vue'
import Cotas from './pages/Cotas.vue'
import Proposta from './pages/Proposta.vue'
import HistoricoPropostas from './pages/HistoricoPropostas.vue'
import Leads from './pages/Leads.vue'
import Crm from './pages/Crm.vue'
import EmBreve from './pages/EmBreve.vue'
import Importacao from './pages/Importacao.vue'
import Dashboard from './pages/Dashboard.vue'
import Bi from './pages/Bi.vue'
import Config from './pages/Config.vue'
import Master from './pages/Master.vue'
import AjudaChat from './components/AjudaChat.vue'
import { MENU } from './menu'
import { LogOut, Menu, Eye, EyeOff } from 'lucide-vue-next'
import { ICONES_MENU } from './iconesMenu'

export default {
  name: 'App',
  components: { AjudaChat, LogOut, Menu, Eye, EyeOff },
  data() {
    return {
      logado: false,
      empresa: 'm-consorcios',
      usuario: '',
      senha: '',
      mostrarSenha: false,
      erroLogin: '',
      entrando: false,
      sessao: { nome: '', perfil: '', usuario: '', token: '', paginasPermitidas: null },
      paginaAtual: 'inicio',
      menuMobileAberto: false,
      sidebarRecolhida: false,
      logoUrl: '',
      nomeEmpresa: 'ConGestor',
      logoMarca,
      logoConGestor,
      empresaLogo: '',
      empresaNome: '',
      mostrarSplash: false
    }
  },
  computed: {
    iconesMenu() {
      return ICONES_MENU
    },
    iniciais() {
      const partes = (this.sessao.nome || '?').trim().split(' ')
      return partes.length > 1 ? (partes[0][0] + partes[partes.length - 1][0]).toUpperCase() : (this.sessao.nome || '?').substring(0, 2).toUpperCase()
    },
    menuVisivel() {
      let itens = MENU.filter(m => !m.adminOnly || this.sessao.perfil === 'admin')
      itens = itens.filter(m => !m.masterOnly || this.sessao.masterAcesso)
      const permitidas = this.sessao.paginasPermitidas
      if (Array.isArray(permitidas)) {
        itens = itens.filter(m => m.id === 'config' || m.id === 'master' || permitidas.includes(m.id))
      }
      return itens
    },
    paginaComponente() {
      const mapa = { inicio: Inicio, links: Links, vendas: Vendas, minhasVendas: MinhasVendas, comissao: Comissao, tabela: TabelaComissao, pagamentos: Pagamentos, minhaSenha: MinhaSenha, metas: Metas, contasPagar: ContasPagar, sorteios: Sorteios, cotas: Cotas, proposta: Proposta, historicoPropostas: HistoricoPropostas, leads: Leads, crm: Crm, importar: Importacao, dashboard: Dashboard, bi: Bi, config: Config, master: Master }
      return mapa[this.paginaAtual] || EmBreve
    }
  },
  created() {
    const s = getSession()
    if (s.token) {
      this.sessao = s
      this.logado = true
      if (s.empresa) this.empresa = s.empresa
      this.carregarCorTema()
    }
    this.carregarLogo()
    window.addEventListener('siscon-navigate', this.onSisconNavigate)
  },
  beforeUnmount() {
    window.removeEventListener('siscon-navigate', this.onSisconNavigate)
  },
  methods: {
    onSisconNavigate(e) {
      this.irPara(e.detail)
    },
    async carregarLogo() {
      try {
        const r = await apiPublicGet('config/logo-publico', { empresa: this.empresa || 'm-consorcios' })
        if (r.sucesso) {
          this.empresaLogo = r.valor || ''
          this.empresaNome = r.nome || this.empresa || ''
          if (this.logado) {
            this.logoUrl = this.empresaLogo
            this.nomeEmpresa = this.empresaNome || 'ConGestor'
            setNomeEmpresaCache(this.nomeEmpresa)
          }
        }
      } catch (e) { /* sem identidade da empresa configurada */ }
    },
    async carregarCorTema() {
      try {
        const r = await apiGet('config/get', { chave: 'COR_TEMA' })
        if (r.sucesso && r.valor) aplicarCorTema(r.valor)
      } catch (e) { /* mantem cor padrao */ }
    },
    async entrar() {
      if (!this.empresa || !this.usuario || !this.senha) { this.erroLogin = 'Preencha empresa, usuario e senha.'; return }
      this.erroLogin = ''
      this.entrando = true
      try {
        const r = await apiPublicPost('auth/login', { empresa: this.empresa, usuario: this.usuario, senha: this.senha })
        if (r.sucesso) {
          await this.carregarLogo()
          setSession({ token: r.token, nome: r.nome, perfil: r.perfil, usuario: this.usuario, paginasPermitidas: r.paginasPermitidas, empresa: this.empresa, masterAcesso: r.masterAcesso })
          this.sessao = { token: r.token, nome: r.nome, perfil: r.perfil, usuario: this.usuario, paginasPermitidas: r.paginasPermitidas || null, masterAcesso: r.masterAcesso || '' }
          this.logoUrl = this.empresaLogo
          this.nomeEmpresa = this.empresaNome || 'ConGestor'
          setNomeEmpresaCache(this.nomeEmpresa)
          await this.carregarCorTema()
          this.logado = true
          this.mostrarSplash = true
          setTimeout(() => { this.mostrarSplash = false }, 1500)
        } else {
          this.erroLogin = r.mensagem || 'Usuario ou senha invalidos.'
        }
      } catch (e) {
        this.erroLogin = 'Erro de conexao. Tente novamente.'
      } finally {
        this.entrando = false
      }
    },
    sair() {
      clearSession()
      this.logado = false
      this.usuario = ''
      this.senha = ''
      this.paginaAtual = 'inicio'
      this.logoUrl = ''
      this.nomeEmpresa = 'ConGestor'
      limparCorTema()
    },
    irPara(id) {
      this.paginaAtual = id
      this.menuMobileAberto = false
    }
  }
}
</script>
